/// <amd-module name="SuiteCommerce.ShippingBar.CartShippingBar.View"/>
define("SuiteCommerce.ShippingBar.CartShippingBar.View", ["require", "exports", "Backbone", "suitecommerce_shippingbar_cart.tpl", "SuiteCommerce.ShippingBar.Common.Utils"], function (require, exports, Backbone_1, suitecommerce_shippingbar_cart_tpl, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ShippingBarCartView = Backbone_1.View.extend({
        template: suitecommerce_shippingbar_cart_tpl,
        title: Utils_1.Utils.translate('cart-shipping-bar'),
        initialize: function (options) {
            var _this = this;
            var model = options.model;
            model.on('cartAmount:changed', function () {
                _this.render();
            });
            model.on('pdpAmount:changed', function () {
                _this.render();
            });
        },
        getContext: function getContext() {
            var currentValue = this.model.get('cartAmount');
            var cartCongratsMessage = this.model.get('cartCongratsMessage');
            var cartProgressMessage = this.model.getMessage('cartProgressMessage', currentValue);
            var cartInitialMessage = this.model.getMessage('cartInitialMessage', 0);
            var isInProgress = 0 < this.model.get('cartAmount');
            var shippingGoalAvailable = currentValue >= this.model.attributes.shippingAmount;
            var showBanner = true;
            if (shippingGoalAvailable) {
                showBanner = !!cartCongratsMessage;
            }
            // tslint:disable-next-line:brace-style
            else if (isInProgress) {
                showBanner = !!cartProgressMessage;
            }
            else
                showBanner = !!cartInitialMessage;
            return {
                shippingGoalAvailable: shippingGoalAvailable,
                isInProgress: isInProgress,
                showBanner: showBanner,
                cartCongratsMessage: cartCongratsMessage,
                cartProgressMessage: cartProgressMessage,
                cartInitialMessage: cartInitialMessage,
                device: this.options.device,
            };
        },
    });
});
